module.exports = __webpack_public_path__ + "website/img/core6_1.3bf94ec5.png";